module.exports = __webpack_public_path__ + "img/imgYLSYB(9).9db87650.png";